/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetOverviewRequest,
  UtxGlobalMarketDataApiGetOverviewParams,
  UtxGlobalMarketDataApiGetPageDetailParams,
  UtxGlobalMarketDataApiGetPageParams
} from './schema'



export const utxGlobalMarketDataApiGetOverview = (
    params: UtxGlobalMarketDataApiGetOverviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetOverviewRequest[]>> => {
    return axios.get(
      `/global-market-data-service/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxGlobalMarketDataApiGetOverviewQueryKey = (params: UtxGlobalMarketDataApiGetOverviewParams,) => [`/global-market-data-service/overview`, ...(params ? [params]: [])];

    
export type UtxGlobalMarketDataApiGetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetOverview>>>
export type UtxGlobalMarketDataApiGetOverviewQueryError = AxiosError<unknown>

export const useUtxGlobalMarketDataApiGetOverview = <TData = Awaited<ReturnType<typeof utxGlobalMarketDataApiGetOverview>>, TError = AxiosError<unknown>>(
 params: UtxGlobalMarketDataApiGetOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxGlobalMarketDataApiGetOverviewQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetOverview>>> = ({ signal }) => utxGlobalMarketDataApiGetOverview(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxGlobalMarketDataApiGetPageDetail = (
    params?: UtxGlobalMarketDataApiGetPageDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/global-market-data-service/page-detail`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxGlobalMarketDataApiGetPageDetailQueryKey = (params?: UtxGlobalMarketDataApiGetPageDetailParams,) => [`/global-market-data-service/page-detail`, ...(params ? [params]: [])];

    
export type UtxGlobalMarketDataApiGetPageDetailQueryResult = NonNullable<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPageDetail>>>
export type UtxGlobalMarketDataApiGetPageDetailQueryError = AxiosError<unknown>

export const useUtxGlobalMarketDataApiGetPageDetail = <TData = Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPageDetail>>, TError = AxiosError<unknown>>(
 params?: UtxGlobalMarketDataApiGetPageDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPageDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxGlobalMarketDataApiGetPageDetailQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPageDetail>>> = ({ signal }) => utxGlobalMarketDataApiGetPageDetail(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPageDetail>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxGlobalMarketDataApiGetPage = (
    params: UtxGlobalMarketDataApiGetPageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/global-market-data-service/page`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxGlobalMarketDataApiGetPageQueryKey = (params: UtxGlobalMarketDataApiGetPageParams,) => [`/global-market-data-service/page`, ...(params ? [params]: [])];

    
export type UtxGlobalMarketDataApiGetPageQueryResult = NonNullable<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPage>>>
export type UtxGlobalMarketDataApiGetPageQueryError = AxiosError<unknown>

export const useUtxGlobalMarketDataApiGetPage = <TData = Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPage>>, TError = AxiosError<unknown>>(
 params: UtxGlobalMarketDataApiGetPageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPage>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxGlobalMarketDataApiGetPageQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPage>>> = ({ signal }) => utxGlobalMarketDataApiGetPage(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxGlobalMarketDataApiGetPage>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

